import React from "react";

import { Routes, Route, Navigate } from "react-router-dom";

import AdminRoutes from "./admin/AdminRoutes";

import FrontendRoutes from "./frontend/FrontendRoutes";

import { CartProvider } from "./frontend/context/CartContext";

import { AuthProvider } from "./frontend/context/AuthContext";

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Routes>
          <Route path="/*" element={<FrontendRoutes />} />
          <Route path="/admin/*" element={<AdminRoutes />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </CartProvider>
    </AuthProvider>
  );
}
